<template>
  <Card
    tone="default"
    padding="lg"
    class="flex h-full flex-col gap-4 hover:shadow-md hover:shadow-accent/50"
    data-testid="solution-card"
  >
    <div
      class="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-accent-soft text-accent-strong"
    >
      <BaseIcon name="check" :size="20" />
    </div>

    <h3 class="text-base font-bold text-ink-strong md:text-lg">{{ title }}</h3>

    <p class="text-sm text-ink-muted">{{ description }}</p>

    <ul v-if="details.length > 0" class="flex flex-col gap-1.5 text-sm text-ink">
      <li v-for="item in details" :key="item" class="flex items-start gap-2">
        <BaseIcon name="check" :size="16" class="mt-0.5 shrink-0 text-accent" />
        <span>{{ item }}</span>
      </li>
    </ul>

    <div class="mt-auto">
      <BaseButton v-if="hasLink && to" variant="link" size="sm" as="router-link" :to="to">
        {{ ctaLabel }}
      </BaseButton>
      <BaseButton v-else variant="link" size="sm" @click="$emit('open')">
        {{ ctaLabel }}
      </BaseButton>
    </div>
  </Card>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { RouteLocationRaw } from 'vue-router';
import Card from '@/components/primitives/Card.vue';
import BaseButton from '@/components/base/BaseButton.vue';
import BaseIcon from '@/components/base/BaseIcon.vue';

interface Props {
  title: string;
  description: string;
  details?: readonly string[];
  ctaLabel: string;
  /**
   * Если задан — CTA-кнопка «Подробнее» рендерится как `<router-link>`
   * на эту цель. В этом режиме событие `open` не эмитится. Заголовок и
   * остальная часть карточки остаются некликабельными.
   */
  to?: RouteLocationRaw | null;
}

const props = withDefaults(defineProps<Props>(), {
  details: () => [],
  to: null,
});

defineEmits<{
  (e: 'open'): void;
}>();

const hasLink = computed(() => props.to !== null && props.to !== undefined);
</script>
